<div class="view-component-title">
    <button nz-button nzType="text" (click)="_dynaServices.changeFace()" [nz-tooltip]="_dynaServices.faceToolTip">
        <generic-icon [iconName]="_dynaServices.gridBound" type="google"></generic-icon>
    </button>
    <div class="vl"></div>
    <button nz-button nzType="text" (click)="_dynaServices.gotoFirstRow()" nz-tooltip="Ir para o início">
        <nz-icon nzType="double-left"></nz-icon>
    </button>
    <button nz-button nzType="text" (click)="_dynaServices.gotoBefRow()" nz-tooltip="Voltar">
        <nz-icon nzType="left"></nz-icon>
    </button>
    <button nz-button nzType="text" (click)="_dynaServices.gotoNextRow()" nz-tooltip="Avançar">
        <nz-icon nzType="right"></nz-icon>
    </button>
    <button nz-button nzType="text" (click)="_dynaServices.gotoLastRow()" nz-tooltip="Ir para o fim">
        <nz-icon nzType="double-right"></nz-icon>
    </button>
    <div class="vl"></div>
    <button nz-button nzType="text" (click)="addRow()" [disabled]="stopAdd" nz-tooltip="Novo">
        <nz-icon nzType="plus"></nz-icon>
    </button>
    <button nz-button nzType="text" (click)="_dynaServices.removeRow()" [disabled]="stopRemove" nz-tooltip="Excluir">
        <nz-icon nzType="minus"></nz-icon>
    </button>
    <button nz-button nzType="text" (click)="saveRow()" [disabled]="!_dynaServices.enableSave" nz-tooltip="Salvar">
        <nz-icon nzType="check"></nz-icon>
    </button>
    <button nz-button nzType="text" (click)="cancelEditing()" [disabled]="!_dynaServices.editingRow" nz-tooltip="Cancelar">
        <nz-icon nzType="close"></nz-icon>
    </button>
    <button nz-button nzType="text" (click)="duplicate()" [disabled]="dynaServices.selectedRow.length!=1" nz-tooltip="Duplicar">
        <nz-icon nzType="copy"></nz-icon>
    </button>
    <button nz-button nzType="text" (click)="_dynaServices.fetch(0,false,false)" nz-tooltip="Atualizar">
        <nz-icon nzType="reload"></nz-icon>
    </button>
    <div class="vl"></div>
    <div class="filter-field">
        <input nz-input #input (keyup)="updateFilter($event)" placeholder="Expressão de Filtro" [nzAutocomplete]="auto" (input)="_dynaServices.filterExpression = $event.target.value" [value]="_dynaServices.filterExpression" />
        <nz-autocomplete #auto="nzAutocomplete" (selectionChange)="_dynaServices.filterExpression = $event?.nzValue ?? $event">
            <nz-auto-option *ngFor="let option of filters" [nzValue]="option">
                {{option}}
            </nz-auto-option>
        </nz-autocomplete>
    </div>
    <div class="vl"></div>
    <div class="flex-spacer"></div>
    <button nz-button nzType="text" (click)="expandFields()" nz-tooltip="Ajustar colunas">
        <nz-icon nzType="expand"></nz-icon>
    </button>
    <button nz-button nzType="text" (click)="openFieldsSelect()" nz-tooltip="Configurar colunas">
        <nz-icon nzType="setting"></nz-icon>
    </button>
    <button *ngIf="showAction" nz-button nzType="text" nz-dropdown [nzDropdownMenu]="menu" nz-tooltip="Ações">
        <nz-icon nzType="thunderbolt"></nz-icon>
    </button>
    <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
            <li nz-menu-item *ngFor="let mainItem of actionList" (click)="callCustomAction(mainItem,$event)">
                <generic-icon [iconName]="mainItem.ICON" type="google"></generic-icon>
                <span class="menu-label">{{mainItem.NAME}}</span>
            </li>
        </ul>
    </nz-dropdown-menu>

    <div class="vl"></div>
    <span class="desc">{{instanceDescription}}</span>
</div>
